import React from 'react';
import classnames from 'classnames';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';

import s from './BaseTierUpsell.scss';

export interface Props {
  imageSrc?: string;
  imageWidth?: string;
  title: string;
  subtitle?: string;
  href?: string;
  buttonText?: string;
  className?: string;
  biData?: BiEvent;
  onClick?: () => void;
}

export const BaseTierUpsell: React.FC<Props> = ({
  imageSrc,
  imageWidth,
  title,
  subtitle,
  href,
  buttonText,
  className,
  biData,
  onClick,
}) => {
  return (
    <Section className={classnames(s['root'], className)}>
      {/* they're all different dimensions... */}
      {imageSrc && imageWidth && <img src={imageSrc} alt="" width={imageWidth} />}
      {title && <Heading className={s['title']}>{title}</Heading>}
      {subtitle && <p className={s['subtitle']}>{subtitle}</p>}
      {(href || onClick) && buttonText && (
        <GhostButton
          className={s['button']}
          size="medium"
          variant="main"
          href={href}
          onClick={onClick}
          biData={biData}
        >
          {buttonText}
        </GhostButton>
      )}
    </Section>
  );
};
BaseTierUpsell.displayName = 'BaseTierUpsell';

export default BaseTierUpsell;
